.orb {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
}
